import React, { useEffect, useMemo, useState } from 'react';
import { Button, Table } from 'reactstrap';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import MagnifyIcon from 'mdi-react/MagnifyIcon';
import ArrowUpIcon from 'mdi-react/ArrowUpIcon';
import ArrowDownIcon from 'mdi-react/ArrowDownIcon';
import { getBaseDate } from '../../util/date-and-time';
import Api from '../../util/api';
import { partial } from '../../util/translation/translation';

const s = partial('shared');

const LeagueAdminListPage = () => {
  const [leagues, setLeagues] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [order, setOrder] = useState({ orderBy: 'id', desc: true });

  const fetchLeagues = async () => {
    try {
      const { data } = await Api.clubadmin.leagues.all();
      setLeagues(data);
    } catch (e) {
      toast.error(e || s('somethingWentWrong'));
    }
  };

  const handleSort = (field) => {
    setOrder((prev) => ({
      orderBy: field,
      desc: field === prev.orderBy ? !prev.desc : false,
    }));
  };

  const renderSortIcon = (field) => {
    if (order.orderBy !== field) {
      return null;
    }
    return order.desc ? <ArrowDownIcon size={16} /> : <ArrowUpIcon size={16} />;
  };

  const visibleLeagues = useMemo(() => {
    let result = leagues;
    if (searchText) {
      const search = searchText.toLowerCase();
      result = result.filter((league) =>
        league.name?.toLowerCase().includes(search)
      );
    }
    if (order.orderBy) {
      result = [...result].sort((a, b) => {
        let cmp = 0;
        switch (order.orderBy) {
          case 'id':
            cmp = a.id - b.id;
            break;
          case 'provider':
            cmp = (a.provider || '').localeCompare(b.provider || '');
            break;
          case 'sport':
            cmp = (a.sport || '').localeCompare(b.sport || '');
            break;
          case 'gender':
            cmp = (a.gender || '').localeCompare(b.gender || '');
            break;
          default:
            cmp = (a.name || '').localeCompare(b.name || '');
        }
        return order.desc ? -cmp : cmp;
      });
    }
    return result;
  }, [leagues, searchText, order]);

  const renderLeagues = (_leagues) =>
    _leagues.map((league) => (
      <tr key={`leauge:${league.id}`}>
        <td>{league.id}</td>
        <td>
          <Link to={`/clubadmin/league/edit/${league.id}`}>{league.name}</Link>
        </td>
        <td>{league.provider}</td>
        <td>
          {getBaseDate(league.season?.seasonStart)} -<br />
          {getBaseDate(league.season?.seasonEnd)}
          <br />
          {league.season?.type}
        </td>
        <td>
          {league.sport}, {league.extraData.providerName}
        </td>
        <td>{league.gender}</td>
      </tr>
    ));
  useEffect(() => {
    fetchLeagues();
  }, []);
  return (
    <>
      <div className="flex space-between mb-2">
        <div className="form">
          <div className="form__form-group products-list__search">
            <input
              placeholder={s('search')}
              value={searchText}
              onChange={(event) => setSearchText(event.target.value)}
              name="search"
              className="rounded"
            />
            <MagnifyIcon />
          </div>
        </div>
        <Link to="/clubadmin/league/create">
          <Button color="primary" size="sm">
            Create League
          </Button>
        </Link>
      </div>
      <Table responsive bordered striped>
        <thead>
          <tr>
            <th className="sortable" onClick={() => handleSort('id')}>
              <div className="flex alignItems-center">
                ID {renderSortIcon('id')}
              </div>
            </th>
            <th className="sortable" onClick={() => handleSort('name')}>
              <div className="flex alignItems-center">
                Name {renderSortIcon('name')}
              </div>
            </th>
            <th className="sortable" onClick={() => handleSort('provider')}>
              <div className="flex alignItems-center">
                Provider {renderSortIcon('provider')}
              </div>
            </th>
            <th>Season</th>
            <th className="sortable" onClick={() => handleSort('sport')}>
              <div className="flex alignItems-center">
                Sport {renderSortIcon('sport')}
              </div>
            </th>
            <th className="sortable" onClick={() => handleSort('gender')}>
              <div className="flex alignItems-center">
                Gender {renderSortIcon('gender')}
              </div>
            </th>
          </tr>
        </thead>
        <tbody>{renderLeagues(visibleLeagues)}</tbody>
      </Table>
    </>
  );
};

export default LeagueAdminListPage;
